import React from "react";
import {
  FaUsers,
  FaHamburger,
  FaListOl,
  FaCalendarAlt,
} from "react-icons/fa";

const OtherProducts = () => {
  const products = [
    {
      title: "Skilled Mates",
      description:
        "A platform that connects businesses with workers looking for casual, temporary, or urgent shifts. Free for workers and affordable for businesses.",
      icon: <FaUsers className="text-blue-600 text-5xl mb-4" />,
      link: "https://www.skilledmates.com.au",
      bg: "bg-blue-50 hover:bg-blue-100",
    },
    {
      title: "FoodOrderoo",
      description:
        "An online food ordering solution for cafés and restaurants, allowing customers to place orders easily without queues.",
      icon: <FaHamburger className="text-green-600 text-5xl mb-4" />,
      link: "https://www.foodorderoo.com",
      bg: "bg-green-50 hover:bg-green-100",
    },
    {
      title: "Customer Queue",
      description:
        "A simple queue management system for barbers, salons, and retail stores to manage walk-in customers efficiently.",
      icon: <FaListOl className="text-purple-600 text-5xl mb-4" />,
      link: "https://customerqueue.com",
      bg: "bg-purple-50 hover:bg-purple-100",
    },
     {
      title: "EasyBookThem",
      description:
        "An easy online appointment booking platform for salons, barbers, and other businesses to manage bookings, staff, services, and customers.",
      icon: <FaCalendarAlt className="text-orange-600 text-5xl mb-4" />,
      link: "https://easybookthem.vercel.app/",
      bg: "bg-orange-50 hover:bg-orange-100",
    },
  ];

  const openLink = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4">
      <h1 className="text-3xl font-extrabold text-center text-gray-800 mb-10">
        Our Other Products
      </h1>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {products.map((product, idx) => (
          <div
            key={idx}
            onClick={() => openLink(product.link)}
            className={`${product.bg} cursor-pointer rounded-xl p-8 flex flex-col items-center text-center shadow-md transition transform hover:scale-105`}
          >
            {product.icon}
            <h2 className="text-xl font-bold text-gray-800 mb-2">
              {product.title}
            </h2>
            <p className="text-gray-600 mb-4">{product.description}</p>
            <span className="text-sm font-semibold text-blue-700 underline">
              Visit Website
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OtherProducts;
